import SetIsActive from '@/common/components/SetIsActive'
import { GetLoginAnnouncementTableData } from '@/modules/client-setting/type'
import useMutationUpdateLoginAnnouncement from '@/modules/client-setting/api/hooks/useMutationUpdateLoginAnnouncement'

interface SwitchIsActiveProps {
	row: GetLoginAnnouncementTableData
}

export function IsActiveAnnounce({ row }: SwitchIsActiveProps) {
	const { mutateAsync: updateLoginAnnouncement } =
		useMutationUpdateLoginAnnouncement()

	const handleMutate = async (value: boolean) => {
		await updateLoginAnnouncement({
			id: row.id,
			payload: {
				isActive: value,
			},
		})
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
